module.exports = __webpack_public_path__ + "static/fonts/NotoSans-Black.dbd5cc4.eot";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/fonts/NotoSans-Black.eot?
// module id = ARFf
// module chunks = 0